import { useActionState, useEffect } from "react";
import { access, isString, split, useParameter, useProperty } from "../../support/general";
import { sendCommand } from "../../support/LocalCommand";
import { makeUniversalBlockKey, modelStore, selectionStore } from "../storage/model";
import $ from "jquery"
import { makeStore } from "../../support/pile";
import { ensureSubscriptLoaded, PagedSubscript } from "./EPagedSubscript";
import { Modal, Row } from "react-bootstrap";
import { Directory } from "./EDirectory";
import { onAppMouseMove, onColResizeMouseLeave, onColResizeMouseMove, onColResizeMouseUp } from "./Column";
import { Navigation } from "./ENavigation";
import { documentTypes } from "./subscriptTypes";

export function Script({scriptId,style,onFocussedSubscriptChanged}){

    // console.log("run Script");

    var [getSubscriptId,setSubscriptId] = useProperty(0);

    useEffect(()=>{
        sendCommand({
            actions : [{
                objectType : 'Script',
                verb : 'fetch',
                scriptId : scriptId,
            }],
            onSucceeded : ()=>{
                ensureSubscriptLoaded( scriptId , 1 );
                showSubscript('2')
            }
        });
                
    },[]);

    var script = modelStore.useSelector((state)=>{
        return access(state,["model","Script",scriptId]);
    })

    var showFolder = modelStore.useSelector(state=>{
        return access(state,['model','showFolder']);
    });
    
    var showNavigation = modelStore.useSelector(state=>{
        return access(state,['model','showNavigation']);
    });

    var selectedBlockId = selectionStore.useSelector(state=>{
        return state.model.selectedBlockId;
    })

    var subscript = access(modelStore.state,["model","Script",scriptId,"subscripts",getSubscriptId()]);
    var editor = null;
    if (subscript){
        var model = modelStore.state.model;

        var navList = subscript.navList;
        var orderedIds = subscript.orderedIds;
        var selectedBlockLocation = modelStore.state.getBlockLocation(scriptId,getSubscriptId(),selectedBlockId);
        if (selectedBlockLocation >= 0) {
            var sceneBlockId = -1;
            for (var blockAt = selectedBlockLocation;blockAt;blockAt--){
                var block = model.Block[makeUniversalBlockKey(scriptId,orderedIds[blockAt])];
                if (block.type == 'scene'){
                    sceneBlockId = block.id;
                    break;
                }
            }
            var occupiedNavUnitIndex = -1;

            if (sceneBlockId>=0){
                var sceneBlockUid = makeUniversalBlockKey(scriptId,sceneBlockId);

                for ( var navIndex = 0 ; navIndex<navList.length ; navIndex++ ) {
                    var navUnit = navList[navIndex];
                    if (navUnit.headBlockUid == sceneBlockUid){
                        occupiedNavUnitIndex = navIndex;
                    }
                }
            }
        }

        editor = documentTypes[subscript.type].Editor(scriptId,getSubscriptId());
    }

    function showSubscript(subscriptId){
        ensureSubscriptLoaded( scriptId , subscriptId ); 
        setSubscriptId(subscriptId);
        modelStore.dispatch(state=>{
            state.model.focussedSubscriptId = subscriptId
        })
        onFocussedSubscriptChanged(subscriptId);
    }
    function onSelectedSubscriptChanged(subscriptId){
        showSubscript(subscriptId);
    }

    style = $.extend({

    },style);

    function onSelectedNavigationChanged(blockId){
        $("#"+makeUniversalBlockKey(scriptId,blockId))[0]?.scrollIntoView();
    }

    var subscriptElement = null;
    if (script){
        
        var folder = showFolder?(
            <Directory
                style={{
                    height : '100%'
                }}
                scriptId={scriptId} 
                subscriptId={1}
                onSelectedSubscriptChanged = {onSelectedSubscriptChanged}
                key = "folder"
            />
        ):null;
        
        var navigation = showNavigation?(
            <Navigation
                style={{
                    height : '100%'
                }}
                scriptId={scriptId} 
                subscriptId={getSubscriptId() }
                onSelectedNavigationChanged = { onSelectedNavigationChanged }
                occupiedNavUnitIndex = {occupiedNavUnitIndex}
                key = "navigation"
            />
        ):null;
        
        subscriptElement = <div
            style={style}
            id = "script"
            onMouseMove={onAppMouseMove}
            onMouseUp={onColResizeMouseUp}
        >

            <Row       
                style={{
                    alignItems :'start',
                    height : '100%',
                    width : '100%',
                    overflowY : 'hidden',
                    padding : 0,
                    margin : 0,
                }}
                className="justify-content-md-center"
                direction="horizontal" 
                gap={4}



            >
                {folder}
                {navigation}                
                {editor}

            </Row>
        </div>
    }
    return (subscriptElement)

}


